import React from 'react';

import PageArchive from 'hive-admin/src/components/PageArchive';

import { ADMIN_ALL as FILTERS } from './filters';

import Analytics from './Analytics';
import Overview from './components/Overview';

class PageAnalytics extends PageArchive {
  static config = {
    ...PageArchive.config,
  }

  renderArchiveContent() {
    const { loading, error: errorRaw, data } = this.props;
    const error = (
      errorRaw
      ? (
          errorRaw?.response?.data?.message
          || 'Cannot get analytics, please try again'
        )
      : null
    );
    return (
      <Analytics
        loading={!!loading}
        error={error}
        data={data || null}
      />
    );
  }

  renderHeaderRight() {
    const { data } = this.props;
    if (!data?.pageviews) { return null; }
    return <Overview data={data} $showOn="desktop" />;
  }
}

export default PageAnalytics.create({
  path: '/analytics/views',
  title: 'Views',
  label: 'Views',
  loadUrl: 'integrations/sa',
  getCreateButtonPath: () => null,
  filters: FILTERS,
  createButtonSupported: false,
  // eslint-disable-next-line arrow-body-style
  loadExtractData: (response) => {
    return response?.data || null;
  },
  redirect: [
    ['redirect.unauthorized'],
  ],
  getArchiveQueryMode: () => 'paginated',
});
